// src/pages/CourseTime/utils/sessionScoreLevel.js

// Rubric rows of the session score screen, top to bottom. `max` is the top of a row's
// score range; a row starts at the `max` of the row below it. The scale beside the
// table and the row to highlight both come from these values.
export const SESSION_SCORE_LEVELS = [
  { level: 4, band: 'high', max: 100 },
  { level: 3, band: 'moderate', max: 75 },
  { level: 2, band: 'basic', max: 50 },
  { level: 1, band: 'low', max: 25 },
];

// Bottom of the scale, shown under the last row
export const SESSION_SCORE_MIN = 0;

// (score) => 4 | 3 | 2 | 1 | null
export const getSessionScoreLevel = (score) => {
  // No score (null, '', NaN) means no level, not level 1.
  if (score === null || score === undefined || String(score).trim() === '') return null;
  const numericScore = Number(score);
  if (!Number.isFinite(numericScore)) return null;
  // First row whose range starts at or below the score; the last row takes the rest.
  return SESSION_SCORE_LEVELS.find((row, index, rows) => {
    const rowBelow = rows[index + 1];
    return !rowBelow || numericScore >= rowBelow.max;
  }).level;
};
